const menuBtn = document.getElementById('menu-btn');
const closeBtn = document.getElementById('close-btn');
const mobileMenu = document.getElementById('mobile-menu');
const overlay = document.getElementById('nav-overlay');

function toggleMenu() {
    // Slide the menu in/out
    mobileMenu.classList.toggle('translate-x-full');
    
    // Handle the darkened backdrop
    overlay.classList.toggle('opacity-50');
    overlay.classList.toggle('opacity-0');
    overlay.classList.toggle('pointer-events-auto');
    overlay.classList.toggle('pointer-events-none');
}

menuBtn.addEventListener('click', toggleMenu);
closeBtn.addEventListener('click', toggleMenu);
overlay.addEventListener('click', toggleMenu);